// Beside the pages rather than in them, so each page file exports components only.

const DAY_FMT = new Intl.DateTimeFormat("en-US", {
  month: "short",
  day: "numeric",
});

// Day and time are joined here because newer ICU builds join en-US date and
// time with " at " (and h23 because hour12:false prints midnight as "24:05").
const TIME_FMT = new Intl.DateTimeFormat("en-US", {
  hour: "2-digit",
  minute: "2-digit",
  hourCycle: "h23",
});

/** "Oct 22, 14:05". */
export function formatAuthorizedAt(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return `${DAY_FMT.format(d)}, ${TIME_FMT.format(d)}`;
}

/** "2 min ago", "1 h ago", "3 days ago", "Oct 18" past a week, "Never". */
export function formatLastUsed(
  iso: string | null,
  now: Date = new Date(),
): string {
  if (!iso) return "Never";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  // A server clock a shade ahead of the browser's must not read as the future.
  const sec = Math.max(0, Math.floor((now.getTime() - d.getTime()) / 1000));
  if (sec < 60) return "just now";
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min} min ago`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr} h ago`;
  const day = Math.floor(hr / 24);
  if (day < 7) return `${day} ${day === 1 ? "day" : "days"} ago`;
  return DAY_FMT.format(d);
}

/** "10 s", "2.5 s", "500 ms". */
export function formatTimeout(ms: number): string {
  if (ms < 1000) return `${ms} ms`;
  return `${ms / 1000} s`;
}

/** "1 000" — grouped with a no-break space so the figure never wraps. */
export function formatCount(n: number): string {
  return n.toLocaleString("en-US").replace(/,/g, " ");
}

/** The letter on a client's tile. */
export function clientInitial(name: string): string {
  const first = name.trim().charAt(0);
  return first ? first.toUpperCase() : "?";
}

/** Desktop apps get the dark tile, so two clients of one vendor stay apart. */
export function isDesktopClient(name: string): boolean {
  return /desktop/i.test(name);
}

/** "claude.ai · localhost:53122", with whichever half is unknown left out. */
export function clientMeta(
  host: string | null,
  redirectHost: string | null,
): string {
  return [host, redirectHost].filter(Boolean).join(" · ");
}
